import { Component, Input } from "@angular/core"
import { PromotionalContent } from "src/app/models"
import { DatePipe } from "@angular/common";
import { MatIcon } from "@angular/material/icon"

@Component({
    selector: "valben-prom-content-history",
    templateUrl: "./prom-content-history.component.html",
    styles: [`
        b {
            white-space: nowrap;
        }
    `],
    standalone: true,
    imports: [
        DatePipe,
        MatIcon,
    ],
})

export class PromContentHistoryComponent {
    @Input() values!: PromotionalContent[]
}

